if (!customElements.get('gift-modal')) {
  customElements.define(
    'gift-modal',
    class GiftModal extends HTMLElement {
      constructor() {
        super();

        this.overlay = this.querySelector('#GiftModal-Overlay');
        this.closeButton = this.querySelector('.gift-modal__close');
        this.cancelButton = this.querySelector('.gift-modal__cancel');
        this.addToCartButton = this.querySelector('.gift-modal__add-to-cart');
        this.textarea = this.querySelector('#GiftModal-Message');
        this.charCount = this.querySelector('.gift-modal__char-count');
        this.senderInput = this.querySelector('#GiftModal-Sender');
        this.radioInputs = this.querySelectorAll('input[name="gift_shipping_type"]');
        this.optionLabels = this.querySelectorAll('.gift-modal__option');
        this.errorContainer = this.querySelector('#GiftModal-Error');

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.overlay.addEventListener('click', this.close.bind(this));
        this.closeButton.addEventListener('click', this.close.bind(this));
        this.cancelButton.addEventListener('click', this.close.bind(this));
        this.addToCartButton.addEventListener('click', this.onAddToCart.bind(this));

        this.textarea.addEventListener('input', this.onCharInput.bind(this));

        this.radioInputs.forEach((radio) => {
          radio.addEventListener('change', this.onRadioChange.bind(this));
        });

        this.bindOpeners();
      }

      bindOpeners() {
        document.querySelectorAll('[data-gift-modal-opener]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.open(btn);
          });
        });
      }

      mirrorDeliveryEstimate() {
        const textEl = this.querySelector('#GiftModal-DeliveryText');
        const source = document.querySelector('#delivery-estimate-result p');
        if (textEl && source) {
          textEl.innerHTML = source.innerHTML;
        }
      }

      open(triggeredBy) {
        if (triggeredBy) this.activeElement = triggeredBy;
        this.mirrorDeliveryEstimate();

        setTimeout(() => {
          this.classList.add('animate', 'active');
        });

        this.addEventListener(
          'transitionend',
          () => {
            const focusElement = this.querySelector('.drawer__inner');
            trapFocus(this, focusElement);
          },
          { once: true }
        );

        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
        this.hideError();
      }

      resetForm() {
        this.textarea.value = '';
        this.senderInput.value = '';
        this.charCount.textContent = '0/240';
        this.radioInputs[0].checked = true;
        this.onRadioChange();
        this.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
          cb.checked = false;
        });
      }

      onCharInput() {
        const length = this.textarea.value.length;
        this.charCount.textContent = `${length}/240`;
      }

      onRadioChange() {
        this.optionLabels.forEach((label) => {
          const radio = label.querySelector('input[type="radio"]');
          label.classList.toggle('gift-modal__option--selected', radio.checked);
        });
      }

      showError(message) {
        this.errorContainer.textContent = message;
        this.errorContainer.classList.add('gift-modal__error--visible');
      }

      hideError() {
        this.errorContainer.textContent = '';
        this.errorContainer.classList.remove('gift-modal__error--visible');
      }

      getVariantId() {
        const productForm = document.querySelector('product-form');
        if (!productForm) return null;
        const idInput = productForm.querySelector('[name="id"]');
        return idInput ? idInput.value : null;
      }

      onAddToCart() {
        const variantId = this.getVariantId();
        if (!variantId) {
          this.showError('Não foi possível identificar o produto. Tente novamente.');
          return;
        }

        this.hideError();
        this.addToCartButton.classList.add('gift-modal__add-to-cart--loading');

        const shippingType = this.querySelector('input[name="gift_shipping_type"]:checked').value;
        const message = this.textarea.value.trim();
        const sender = this.senderInput.value.trim();

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        formData.append('properties[_Presente]', 'true');
        formData.append('properties[Tipo de Envio]', shippingType);

        if (message) {
          formData.append('properties[Mensagem no Cartão]', message);
        }
        if (sender) {
          formData.append('properties[De]', sender);
        }

        // Preferências (checkboxes)
        const ocultarValores = this.querySelector('input[name="gift_pref_ocultar_valores"]');
        if (ocultarValores && ocultarValores.checked) {
          formData.append('properties[Ocultar Valores na Caixa]', 'Sim');
        }
        const notaFiscalEmail = this.querySelector('input[name="gift_pref_nota_fiscal_email"]');
        if (notaFiscalEmail && notaFiscalEmail.checked) {
          formData.append('properties[Nota Fiscal por E-mail]', 'Sim');
        }
        const marcarPresente = this.querySelector('input[name="gift_pref_marcar_presente"]');
        if (marcarPresente && marcarPresente.checked) {
          formData.append('properties[Marcar como Presente]', 'Sim');
        }

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (cart && cart.getSectionsToRender) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || 'Erro ao adicionar ao carrinho.');
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'gift-modal',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'gift-modal',
              productVariantId: variantId,
              cartData: response,
            });

            this.resetForm();
            this.close();

            if (cart && cart.renderContents) {
              cart.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch((e) => {
            console.error(e);
            this.showError('Erro inesperado. Tente novamente.');
          })
          .finally(() => {
            this.addToCartButton.classList.remove('gift-modal__add-to-cart--loading');
            if (cart && cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
          });
      }
    }
  );
}
